@if (content$(); as page) {
  <article>
    <header class="section-inset-y header is--content-page no--intro">
      <div class="container header__inner">
        <div class="header__content">
          <h1 class="h2">
            @if (contentType$(); as contentType) {
              @if (contentType !== 'pagina') {
                <small class="text-primary">{{ profile$().name }}</small>
              }
            }
            <span>{{ page.title }}</span>
          </h1>
        </div>
      </div>
    </header>
    @if (page.text) {
      <section class="bg-gray-100 section-inset-y content">
        <div class="container-xs">
          <div class="text-max-width markdown-content" [innerHTML]="page.text | stripEmbed: cookiesAccepted$() || undefined | safe"></div>
        </div>
      </section>
    }
    @if (profile$(); as profile) {
      <section class="section-inset-y">
        <div class="container text-center disease-profile-info__nav">
          <ul class="d-flex flex-wrap mt-6 justify-content-center">
            @for (page of profile.informationPages; track page.id) {
              <li class="mb-2 mr-2">
                <a
                  class="button button-outline button-outline--primary"
                  [routerLink]="['/', 'stofwisselingsziekten', profile.id, profile.name | urlRewrite, 'informatie', page.slug]"
                  [routerLinkActive]="'is--current'"
                >
                  <span>{{ page.title }}</span>
                </a>
              </li>
            }
          </ul>
          <a
            [routerLink]="['/', 'stofwisselingsziekten', profile.id, profile.name | urlRewrite]"
            class="button button-link button-link--primary"
          >
            <fstr-icon [ariaHidden]="true" anchor="icon-arrow-left"></fstr-icon>
            <span>meer over {{ profile.name }}</span>
          </a>
        </div>
      </section>
    }
  </article>
}
